module.exports = __webpack_public_path__ + "img/cloth_g2_hat_15.f38689b0.svg";